import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import PageHeader from "../components/PageHeader";
import CompanyPecBanner from "../components/CompanyPecBanner";
import DataTable from "../components/DataTable";
import LoadingState from "../components/LoadingState";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Landmark } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";

const STATUS_COLORS = {
    "Autorizzato": "bg-[#16A34A]/10 text-[#16A34A] border-[#16A34A]/30",
    "Da verificare": "bg-[#F59E0B]/10 text-[#B45309] border-[#F59E0B]/30",
    "Revocato": "bg-slate-100 text-slate-500 border-slate-200",
    "Sospetto": "bg-[#DC2626]/10 text-[#DC2626] border-[#DC2626]/30",
};

export default function IbansPage() {
    const { companyId, canAdmin } = useAuth();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = async () => {
        setLoading(true);
        try { const { data } = await api.get("/ibans"); setItems(data?.items || []); }
        catch { toast.error("Errore"); }
        finally { setLoading(false); }
    };
    useEffect(() => { load(); /* eslint-disable-next-line */ }, [companyId]);

    const changeStatus = async (id, status) => {
        try { await api.patch(`/ibans/${id}/status`, { status }); toast.success("Stato aggiornato"); load(); }
        catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
    };

    const columns = [
        { key: "iban", header: "IBAN", render: r => (
            <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-[#2563EB]/10 flex items-center justify-center"><Landmark className="w-4 h-4 text-[#2563EB]" /></div>
                <div><div className="text-sm font-mono">{r.iban}</div><div className="text-xs text-[#64748B]">{r.bank_name || "—"}</div></div>
            </div>
        )},
        { key: "account_holder", header: "Intestatario", render: r => r.account_holder || "—" },
        { key: "supplier_name", header: "Fornitore", render: r => r.supplier_name || "—" },
        { key: "verification_source", header: "Verifica", render: r => <span className="text-xs">{r.verification_source}</span> },
        { key: "status", header: "Stato", render: r => <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-semibold border ${STATUS_COLORS[r.status] || ""}`}>{r.status}</span> },
        { key: "actions", header: "", render: r => canAdmin() && r.status !== "Revocato" ? (
            <div className="flex gap-1 justify-end">
                {r.status !== "Autorizzato" && <Button size="sm" variant="outline" data-testid={`iban-authorize-${r.id}`} onClick={() => changeStatus(r.id, "Autorizzato")}>Autorizza</Button>}
                <Button size="sm" variant="outline" className="text-[#DC2626]" data-testid={`iban-revoke-${r.id}`} onClick={() => changeStatus(r.id, "Revocato")}>Revoca</Button>
            </div>
        ) : null, className: "text-right" },
    ];

    return (
        <div className="space-y-6">
            <PageHeader title="IBAN autorizzati" subtitle="Elenco degli IBAN verificati per i fornitori." breadcrumbs={[{ label: "IBAN autorizzati" }]} />
            <CompanyPecBanner />
            {loading ? <LoadingState /> : <DataTable testId="ibans-table" columns={columns} data={items} pageSize={15} getRowKey={r => r.id} emptyTitle="Nessun IBAN" />}
        </div>
    );
}
